import React, { useState } from 'react';
import '../chat-css/TemplatesModal.css';
import { connect } from 'react-redux';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import {
    cancelAction as cancelActionRedux,
    proceedAction as proceedActionRedux,
} from '../../../../../services/confirmAction/action';
import Translate, { t } from '../../../../../components/Translate';
import Input from '../../../../../components-new/Input';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFolder, faFolderOpen } from "@fortawesome/free-solid-svg-icons";
import config from "../../../../../config";

const style = {
    overlay: {
        backgroundColor: config.modalBackgroundColor,
        zIndex: 2000,
    },
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        borderRadius: '20px',
        transform: 'translate(-50%, -50%)',
        padding: '30px',
        border: 'none',
        width: '600px',
        maxHeight: '90vh',
        overflow: 'auto',
    },
};

Modal.setAppElement('#root');

const TemplatesModal = ({ templates, isOpen, user, cancelAction, changeMessageTextToTemplate }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [openFolder, setOpenFolder] = useState(null);

    const closeModal = () => {
        cancelAction();
    };

    const handleClick = (text) => {
        changeMessageTextToTemplate(text);
        cancelAction();
    };

    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    let groupedTemplates = templates.reduce((acc, template) => {
        if (!acc[template.folderName]) acc[template.folderName] = [];
        acc[template.folderName].push(template);
        return acc;
    }, {});

    if (searchQuery) {
        groupedTemplates = Object.entries(groupedTemplates).reduce((acc, [folderName, folderTemplates]) => {
            const matchingTemplates = folderTemplates.filter(template =>
                template.text.toLowerCase().includes(searchQuery.toLowerCase())
            );
            if (matchingTemplates.length > 0) {
                acc[folderName] = matchingTemplates;
            }
            return acc;
        }, {});
    }

    const toggleFolder = (folderName) => {
        setOpenFolder(prev => (prev === folderName ? null : folderName));
    };

    return (
        <Modal closeTimeoutMS={config.closeTimeoutMS} isOpen={isOpen} style={{...style, overflow: 'auto'}}
               onRequestClose={closeModal}>
            <div className="templates-modal" style={{maxWidth: '600px', overflow: 'auto'}}>
                <h2 className="templates-modal-header">
                    <Translate text={'selectTemplate'}/>
                </h2>

                <br/>

                <div className="templates-search">
                    <Input
                        type="text"
                        placeholder={t({ text: 'search', user })}
                        value={searchQuery}
                        onChange={handleSearchChange}
                    />
                </div>

                <div className="template-list">
                    {Object.entries(groupedTemplates).map(([folderName, folderTemplates]) => (
                        <div key={folderName} className="template-folder">
                            <div className="template-folder-header" onClick={() => toggleFolder(folderName)}>
                                <FontAwesomeIcon icon={openFolder === folderName ? faFolderOpen : faFolder} />
                                {folderName}
                            </div>

                            {openFolder === folderName && (
                                <div className="template-block">
                                    {folderTemplates.map(template => (
                                        <div
                                            key={template.id}
                                            className="template-card"
                                            onClick={() => handleClick(template.text)}
                                        >
                                            {template.text}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    ))}
                </div>

            </div>
        </Modal>
    );
};

TemplatesModal.propTypes = {
    templates: PropTypes.array.isRequired,
    user: PropTypes.object.isRequired,
    cancelAction: PropTypes.func.isRequired,
    changeMessageTextToTemplate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
    isOpen: state.confirmAction.isModalOpen,
    user: state.user,
});

const mapDispatchToProps = (dispatch) => ({
    proceedAction: () => dispatch(proceedActionRedux()),
    cancelAction: () => dispatch(cancelActionRedux()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TemplatesModal);



// WEBPACK FOOTER //
// ./src/scenes/dashboard/components/chat/chat-components/TemplatesModal.jsx